<template>
    <div>
        <!-- Info Block -->
        <div class="row mb-6" v-if="!userFeatures.hasOwnProperty('uninvoiced-items')">
            <div class="col">
                <div class="d-flex align-items-center sau-bx">
                    <div class="p-2"><i class="fal fa-info-circle pl-2 sm primary"></i></div>
                    <div class="p-2">
                        <span>Un-invoiced items are upcoming charges that have not yet been invoiced. They will appear as a line item on a future invoice.</span>
                    </div>
                </div>
                <a href="#" class="sau-font xs float-right sau-linx gray" @click.prevent="hideInfo('uninvoiced-items')">Don't show this again</a>
            </div>
        </div>

        <sau-template :retrieved="requestFinished">
            <!-- Fetching Placeholder -->
            <template slot="message">Fetching Un-invoiced Items</template>
            <!-- Data -->
            <template slot="data">
                <table  v-if="filtered.length > 0" id="data-table-pending-charges" class="table table-hover data-table" data-search="Search" cellspacing="0" width="100%">
                    <thead class="d-none">
                        <tr>
                            <th>Details</th>
                            <th class="noshow">ID</th>
                            <th class="noshow">Description</th>
                            <th class="noshow" style="width:150px;">Invoice Date</th>
                            <th class="noshow" style="width:100px;">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in filtered" :key="item.id">
                            <td>
                                <div class="d-flex product-list">
                                    <div>
                                        <i class="product-icons pr-6 pt-2 fal fa-receipt" aria-hidden="true"></i>
                                    </div>
                                    <div>
                                        <p class="product-name">{{ item.description }}</p>
                                        <p class="product-desc"><span class="sau-font-bold">Payment Date: </span>
                                            <span v-if="item.date == 'Tomorrow' || item.date == 'Next Invoice'">{{ item.date }}</span>
                                            <span v-else>{{ item.date | moment('DD/MM/YYYY') }}</span>
                                        </p>
                                        <p class="product-desc"><span class="sau-font-bold">Amount: </span>{{ item.amount | currency }}</p>
                                    </div>
                                </div>
                            </td>
                            <td :data-filter="applyFilter('id', item.id)">{{ item.id }}</td>
                            <td :data-filter="applyFilter('description', item.description)">{{ item.description }}</td>
                            <td :data-filter="applyFilter('invoice-date', item.date)" :data-order="item.date" class="text-right" v-if="item.date == 'Tomorrow' || item.date == 'Next Invoice'">{{ item.date }}</td>
                            <td :data-filter="applyFilter('invoice-date', item.date)" :data-order="convertDate(item.date)" class="text-right" v-else>{{ item.date | moment('DD/MM/YYYY') }}</td>
                            <td :data-filter="applyFilter('amount', item.amount)" class="text-right">{{ item.amount | currency }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-else>

                    <sau-apiro-response type="message">
                        <template slot="message">You don't have any Uninvoiced Items at the moment.</template>
                    </sau-apiro-response>

                </div>
            </template>
        </sau-template>
    </div>
</template>
<script>
import jsFunctions from '@js/store/jqueryFunctions';
export default {
    mixins: [jsFunctions],
    data() {
        return {
            items: [],
            requestFinished: false,
            features: {
                'uninvoiced-items': true
            },
            INVOICE: {
                DONT: 0,
                CRON: 1,
                NEXT: 2,
                NORMAL: 3,
                RECURR: 4
            },
        };
    },
    created() {
        this.startApp();
    },
    computed: {
        filtered() {
            return this.items.map(item => {
                switch (item.invoiceaction) {
                    case this.INVOICE.CRON:
                        item.date = 'Tomorrow';
                        break;
                    case this.INVOICE.NEXT:
                        item.date = 'Next Invoice';
                        break;
                    case this.INVOICE.NORMAL:
                    case this.INVOICE.RECURR:
                        item.date = item.duedate;
                        break;
                }
                return item;
            });
        }
    },
    methods: {
        startApp() {
            this.getUninvoicedItems().then(response => {
                this.items = response.data;
                this.requestFinished = true;
            }).catch(error => {
                this.requestFinished = true;
            });
        },  
        applyFilter(column, data) {
            return column + ":" + data;
        },
    },
    watch: {
        filtered() {
            this.$nextTick(() => {
                this.initializeDataTables();
            });
        }
    }
};
</script>
<style>
    .product-list i.product-icons {
        font-size:4rem;
        margin: 10px auto;
    }
    #data-table-pending-charges a {
        color:#666;
        text-decoration: none;
    }
</style>
